import{p as r}from"./parse.js";const s=r;var e=(r,e)=>{const o=s(r.trim().replace(/^[=v]+/,""),e);return o?o.version:null};export{e as c};
